export const Reports = {
  spam: 1,
  fake: 2,
  violence: 3,
  copyright: 5,
  other: 6,
};

export const ReportReasons = Object.entries(Reports).map(([key, value]) => ({
  value,
  label: key.toUpperCase(),
}));
